import {AsyncDecl, GroupDecl, NestedDecl, RuleDecl, ValidationDecl} from "vue/types/options";
import {MultiLanguageObject} from "@api/models/objects/MultiLanguageObject";
import {setObjectValue} from "@common/ObjectsHelper";
import {Element} from "@api/models/Element";


const setValue = (
    object: Record<string, any>,
    multiLanguageObject: MultiLanguageObject<any>,
    fieldName: string,
    fieldRules: ValidationDecl | GroupDecl | AsyncDecl | NestedDecl
) => {
     if (multiLanguageObject.schemaSettings.isFieldLocalizable(fieldName)) {
          multiLanguageObject.languageService.list.forEach(language => {
               setObjectValue(object, [language, fieldName], fieldRules);
          })
     }
     else {
          setObjectValue(object, [multiLanguageObject.languageService.baseLanguage, fieldName], fieldRules);
     }
}

export const createValidationObjectForMultiLanguage = <T extends Element>(
    variableName: string,
    rules: Record<keyof T, ValidationDecl | GroupDecl | AsyncDecl | NestedDecl>,
    multiLanguageObject: MultiLanguageObject<T>
) => {
     const result: Record<string, any> = {};

     for (const [fieldName, fieldRules] of Object.entries(rules)) {
          setValue(result, multiLanguageObject, fieldName, fieldRules);
     }

     return {
          [variableName]: {
               data: result
          }
     }
}
